import { initI18n } from './i18n';
import { loadLocaleData } from './i18n/localeData';

// The language and its catalog are loaded before the app modules are imported, so strings built at
// module level (column definitions, option lists) are created in the user's language.
initI18n()
  .then(loadLocaleData)
  .catch(e => console.error('[i18n] start-up failed, continuing in English', e))
  .finally(() => import('./bootstrap'));
